<script>
	import Home from './routes/home.svelte'
	import StoryList from './routes/storylist.svelte'
	import StoryInfo from './routes/storyinfo.svelte'
	import StoryPlayer from './routes/storyplayer.svelte'
	import MainMap from './routes/map.svelte'
	import Error from './routes/error.svelte'
	import End from './routes/end.svelte'

	import Router from 'svelte-spa-router'

	const routes = {
		'/': Home,
		'/stories': StoryList,
		'/story/:id/play': StoryPlayer,
		'/story/:id': StoryInfo,
		'/map': MainMap,
		'/end': End,
		'*': Error,
	}

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
</script>

<Router {routes} />
